module.exports = __webpack_public_path__ + "static/media/julogo.efdc3ddd.png";